import { sendGTMEvent } from '@next/third-parties/google'

const useAnalytics = () => {
  const track = (event: string, data?: object) => {
    window.umami?.track(event, data);
    sendGTMEvent({ event, ...data });
  };
  return {
    track
  }
}

export default useAnalytics;
